import React, { useState, useEffect } from 'react';
import { X, Star, Award, Users, TrendingUp, ChevronLeft, ChevronRight, Play, Pause } from 'lucide-react';

export const VirtualAssistant = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [currentEmojiIndex, setCurrentEmojiIndex] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(true);
  
  // Emojis qui tournent en boucle
  const emojis = ['👇', '⚡️', '🔥', '✨', '💥'];

  // Messages avec POSTS GOOGLE de la fiche établissement
  const messages = [
    {
      icon: "👋",
      title: "Bonjour !",
      text: "Bienvenue chez K&O PHONELAB, votre expert en réparation à Villeurbanne !",
      duration: 4000
    },
    {
      icon: "🕘",
      title: "Ouvert NON-STOP 9h-19h",
      text: "Vous manquez de temps ? Profitez de votre pause déjeuner pour passer en boutique ! Ouvert en continu, même entre midi et deux.",
      duration: 5500,
      isGooglePost: true
    },
    {
      icon: "🚋",
      title: "Tram T6 Gratte-Ciel",
      text: "À la limite de l'arrêt du tram T6 - Gratte-Ciel. 6 Rue Paul Verlaine, 69100 Villeurbanne.",
      duration: 5000,
      isGooglePost: true
    },
    {
      icon: "📱",
      title: "Réparation Express",
      text: "Smartphones, tablettes, ordinateurs et consoles réparés en 15 minutes !",
      duration: 4500
    },
    {
      icon: "🔍",
      title: "Diagnostic GRATUIT",
      text: "Diagnostic complet gratuit + devis détaillé accepté par 99% des assurances.",
      duration: 5000
    },
    {
      icon: "⭐",
      title: "Note Google 4.8/5",
      text: "Plus de 5000 clients satisfaits nous font confiance depuis 10 ans !",
      duration: 4500
    },
    {
      icon: "💳",
      title: "Paiement Facilité",
      text: "Paiement en plusieurs fois disponible. Vente d'accessoires et appareils.",
      duration: 4500,
      isGooglePost: true
    },
    {
      icon: "🎯",
      title: "Devis Gratuit",
      text: "Un écran cassé le matin ? Passez entre midi et deux, repartez réparé !",
      duration: 5000
    }
  ];

  // Écouter l'événement personnalisé pour ouvrir le modal
  useEffect(() => {
    const handleOpenVirtualAssistant = () => {
      handleOpen();
    };
    
    window.addEventListener('openVirtualAssistant', handleOpenVirtualAssistant);
    
    return () => {
      window.removeEventListener('openVirtualAssistant', handleOpenVirtualAssistant);
    };
  }, []);

  // Animation des emojis (rotation rapide)
  useEffect(() => {
    const emojiTimer = setInterval(() => {
      setCurrentEmojiIndex((prev) => (prev + 1) % emojis.length);
    }, 600);

    return () => clearInterval(emojiTimer);
  }, []);

  // Défilement automatique des messages (mode diaporama)
  useEffect(() => {
    if (!isOpen || !isAutoPlay) return;

    const currentMessage = messages[currentTextIndex];
    
    const timer = setTimeout(() => {
      if (currentTextIndex < messages.length - 1) {
        setCurrentTextIndex(currentTextIndex + 1);
      } else {
        setCurrentTextIndex(0);
      }
    }, currentMessage.duration);

    return () => clearTimeout(timer);
  }, [isOpen, currentTextIndex, isAutoPlay]);

  const handleOpen = () => {
    setIsOpen(true);
    setCurrentTextIndex(0);
    setIsAutoPlay(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setCurrentTextIndex(0);
  };

  const goToNext = () => {
    setIsAutoPlay(false);
    setCurrentTextIndex((prev) => (prev + 1) % messages.length);
  };

  const goToPrevious = () => {
    setIsAutoPlay(false);
    setCurrentTextIndex((prev) => (prev - 1 + messages.length) % messages.length);
  };

  const goToMessage = (index) => {
    setIsAutoPlay(false);
    setCurrentTextIndex(index);
  };

  const toggleAutoPlay = () => {
    setIsAutoPlay(!isAutoPlay);
  };

  const currentMessage = messages[currentTextIndex];

  return (
    <>
      {/* VirtualAssistant DÉSACTIVÉ - Avatar supprimé */}
      {/* L'avatar flottant a été retiré à la demande du client */}

      {/* Modal avec les messages (mode carrousel) - RESTE FONCTIONNEL via QuickActionsBar */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] p-2 md:p-4 animate-fadeIn overflow-y-auto"
          onClick={handleClose}
        >
          <div 
            className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full my-auto max-h-[95vh] md:max-h-[90vh] overflow-y-auto animate-slideUp relative z-[10000]"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header - SIMPLIFIÉ avec bouton fermer */}
            <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white p-4 md:p-6 relative sticky top-0 z-[10001] rounded-t-3xl">
              <div className="flex items-center justify-between">
                {/* Contenu principal */}
                <div className="flex items-center space-x-3 flex-1">
                  <div className="text-4xl md:text-5xl">{currentMessage.icon}</div>
                  <div>
                    <h3 className="text-xl md:text-2xl font-bold">K&O PHONELAB</h3>
                    <p className="text-blue-100 text-sm">Message {currentTextIndex + 1}/{messages.length}</p>
                  </div>
                </div>
                
                {/* Bouton de fermeture */}
                <button
                  onClick={handleClose}
                  className="p-2 md:p-3 bg-red-500 hover:bg-red-600 text-white rounded-full shadow-2xl transition-all transform hover:scale-110 flex-shrink-0 ml-2"
                  aria-label="Fermer"
                >
                  <X size={24} strokeWidth={3} />
                </button>
              </div>
            </div>

            {/* Contenu avec scroll */}
            <div className="p-4 md:p-8 space-y-4 md:space-y-6">
              {/* Message actuel avec animation */}
              <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-4 md:p-6 border-l-4 border-blue-500 shadow-lg min-h-[120px] md:min-h-[140px] animate-fadeIn">
                <h4 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 md:mb-3">
                  {currentMessage.title}
                </h4>
                <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                  {currentMessage.text}
                </p>
              </div>

              {/* Navigation manuelle */}
              <div className="flex items-center justify-between">
                <button
                  onClick={goToPrevious}
                  className="p-3 bg-blue-100 hover:bg-blue-200 rounded-full transition-colors"
                  title="Message précédent"
                >
                  <ChevronLeft size={24} className="text-blue-600" />
                </button>

                {/* Points de pagination */}
                <div className="flex space-x-2">
                  {messages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => goToMessage(index)}
                      className={`h-3 rounded-full transition-all duration-300 ${
                        index === currentTextIndex
                          ? 'w-8 bg-blue-600'
                          : 'w-3 bg-gray-300 hover:bg-gray-400'
                      }`}
                      title={`Message ${index + 1}`}
                    />
                  ))}
                </div>

                <button
                  onClick={goToNext}
                  className="p-3 bg-blue-100 hover:bg-blue-200 rounded-full transition-colors"
                  title="Message suivant"
                >
                  <ChevronRight size={24} className="text-blue-600" />
                </button>
              </div>

              {/* Compteur */}
              <div className="text-center text-sm text-gray-600">
                Message {currentTextIndex + 1} sur {messages.length}
                {isAutoPlay && <span className="ml-2 text-blue-600">• Lecture automatique</span>}
              </div>

              {/* Stats visuelles */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-yellow-50 rounded-xl p-4 text-center border border-yellow-200">
                  <Star className="mx-auto mb-2 text-yellow-500" size={28} fill="currentColor" />
                  <div className="text-2xl font-bold text-gray-900">4.8/5</div>
                  <div className="text-sm text-gray-600">Google</div>
                </div>
                <div className="bg-green-50 rounded-xl p-4 text-center border border-green-200">
                  <Award className="mx-auto mb-2 text-green-600" size={28} />
                  <div className="text-2xl font-bold text-gray-900">99%</div>
                  <div className="text-sm text-gray-600">Accepté</div>
                </div>
                <div className="bg-blue-50 rounded-xl p-4 text-center border border-blue-200">
                  <Users className="mx-auto mb-2 text-blue-600" size={28} />
                  <div className="text-2xl font-bold text-gray-900">5000+</div>
                  <div className="text-sm text-gray-600">Clients</div>
                </div>
                <div className="bg-purple-50 rounded-xl p-4 text-center border border-purple-200">
                  <TrendingUp className="mx-auto mb-2 text-purple-600" size={28} />
                  <div className="text-2xl font-bold text-gray-900">10 ans</div>
                  <div className="text-sm text-gray-600">Expérience</div>
                </div>
              </div>

              {/* Bouton d'action unique */}
              <button
                onClick={() => {
                  handleClose();
                  document.getElementById('quote')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-4 rounded-xl font-bold text-lg hover:from-blue-700 hover:to-blue-800 transition-all transform hover:scale-105 shadow-lg"
              >
                📄 Demander un devis gratuit
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
